'use client'
import Image from 'next/image'
import { cn } from '@/utils/twMerge'
import { PrismicLink } from '@prismicio/react'
import { getLangPath } from '@/utils/getLangFormat'

type PathType = 'blog' | 'hub' | 'glossary'

import { useLocale } from '@/context/LocaleContext'

interface BreadcrumbProps {
  title: string | undefined
  path: string
  pathType: PathType
}

const pathMap: Record<PathType, string> = {
  blog: '/blog',
  hub: '/hub',
  glossary: '/glossary',
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ title, path, pathType }) => {
  const locale = useLocale()
  const getPath = () => {
    if (locale === 'en-us') {
      return pathType === 'hub' ? `${pathMap[pathType]}/${path}` : pathMap[pathType]
    }
    return `/${getLangPath(locale)}${pathType === 'hub' ? `${pathMap[pathType]}/${path}` : pathMap[pathType]}`
  }

  return (
    <ul className="flex items-center pb-8 [&_a:hover]:text-primary-green-150 [&_a>img]:ml-1 [&_a>img]:mr-6 [&_a>img]:md:mr-2 [&_a]:flex">
      <li
        className={cn(
          'font-halyardDisplay text-xl text-primary-ink-85 md:text-2xl',
          pathType === 'hub' ? 'uppercase' : 'capitalize',
        )}>
        <PrismicLink href={getPath()}>
          <span className="relative top-[-2px]">{path}</span>
          <Image
            src="/images/angle-right-green.svg"
            width={20}
            height={16}
            alt=""
            aria-hidden="true"
            className="shrink-0"
          />
        </PrismicLink>
      </li>
      <li className="relative font-halyardDisplay text-base text-primary-ink-60 md:text-xl">{title}</li>
    </ul>
  )
}

export default Breadcrumb
